export default __webpack_public_path__ + "static/media/Group9238.91a2ebc7.svg";